export const REQUEST_ESPECIALIDADES_ALL = 'REQUEST_ESPECIALIDADES_ALL'
export const RECEIVE_ESPECIALIDADES_ALL = 'RECEIVE_ESPECIALIDADES_ALL'

export const REQUEST_ESPECIALIDADES = 'REQUEST_ESPECIALIDADES'
export const RECEIVE_ESPECIALIDADES = 'RECEIVE_ESPECIALIDADES'

export const REQUEST_ENDERECOS = 'REQUEST_ENDERECOS'
export const RECEIVE_ENDERECOS = 'RECEIVE_ENDERECOS'

export const REQUEST_SEARCH = 'REQUEST_SEARCH'
export const RECEIVE_SEARCH = 'RECEIVE_SEARCH'

export const REQUEST_MEDICO = 'REQUEST_MEDICO'
export const RECEIVE_MEDICO = 'RECEIVE_MEDICO'
export const RESET_MEDICO = 'RESET_MEDICO'

export const REQUEST_MEDICO_CALENDAR = 'REQUEST_MEDICO_CALENDAR'
export const RECEIVE_MEDICO_CALENDAR = 'RECEIVE_MEDICO_CALENDAR'

export const REQUEST_MEDICO_RATINGS = 'REQUEST_MEDICO_RATINGS'
export const RECEIVE_MEDICO_RATINGS = 'RECEIVE_MEDICO_RATINGS'

export const REQUEST_RATING = 'REQUEST_RATING'
export const RECEIVE_RATING = 'RECEIVE_RATING'
export const REQUEST_SAVE_RATING = 'REQUEST_SAVE_RATING'
export const RECEIVE_SAVE_RATING = 'RECEIVE_SAVE_RATING'

export const REQUEST_PLANTAO = 'REQUEST_PLANTAO'
export const RECEIVE_PLANTAO = 'RECEIVE_PLANTAO'

export const REQUEST_PLANTAO_FILA = 'REQUEST_PLANTAO_FILA'
export const RECEIVE_PLANTAO_FILA = 'RECEIVE_PLANTAO_FILA'

export const REQUEST_PLANTAO_UNICO_PRICE = 'REQUEST_PLANTAO_UNICO_PRICE'
export const RECEIVE_PLANTAO_UNICO_PRICE = 'RECEIVE_PLANTAO_UNICO_PRICE'

export const REQUEST_SAVE_PLANTAO_UNICO = 'REQUEST_SAVE_PLANTAO_UNICO'
export const RECEIVE_SAVE_PLANTAO_UNICO = 'RECEIVE_SAVE_PLANTAO_UNICO'

export const REQUEST_ATENDIMENTO = 'REQUEST_ATENDIMENTO'
export const RECEIVE_ATENDIMENTO = 'RECEIVE_ATENDIMENTO'

export const REQUEST_CREATE_ATENDIMENTO = 'REQUEST_CREATE_ATENDIMENTO'
export const RECEIVE_CREATE_ATENDIMENTO = 'RECEIVE_CREATE_ATENDIMENTO'
export const RESET_CREATE_ATENDIMENTO = 'RESET_CREATE_ATENDIMENTO'

export const REQUEST_JOIN_QUEUE = 'REQUEST_JOIN_QUEUE'
export const RECEIVE_JOIN_QUEUE = 'RECEIVE_JOIN_QUEUE'
export const RESET_JOIN_QUEUE = 'RESET_JOIN_QUEUE'

export const REQUEST_LEAVE_QUEUE = 'REQUEST_LEAVE_QUEUE'
export const RECEIVE_LEAVE_QUEUE = 'RECEIVE_LEAVE_QUEUE'
export const RESET_LEAVE_QUEUE = 'RESET_LEAVE_QUEUE'

export const REQUEST_RESCHEDULE = 'REQUEST_RESCHEDULE'
export const RECEIVE_RESCHEDULE = 'RECEIVE_RESCHEDULE'
export const RESET_RESCHEDULE = 'RESET_RESCHEDULE'

export const REQUEST_SCHEDULE_RETURN = 'REQUEST_SCHEDULE_RETURN'
export const RECEIVE_SCHEDULE_RETURN = 'RECEIVE_SCHEDULE_RETURN'
export const RESET_SCHEDULE_RETURN = 'RESET_SCHEDULE_RETURN'

export const REQUEST_SCHEDULE_CANCEL = 'REQUEST_SCHEDULE_CANCEL'
export const RECEIVE_SCHEDULE_CANCEL = 'RECEIVE_SCHEDULE_CANCEL'
export const RESET_SCHEDULE_CANCEL = 'RESET_SCHEDULE_CANCEL'

export const REQUEST_MEDICAL_RECORDS = 'REQUEST_MEDICAL_RECORDS'
export const RECEIVE_MEDICAL_RECORDS = 'RECEIVE_MEDICAL_RECORDS'
export const RESET_MEDICAL_RECORDS = 'RESET_MEDICAL_RECORDS'

export const REQUEST_INVOICE_REQUEST = 'REQUEST_INVOICE_REQUEST'
export const RECEIVE_INVOICE_REQUEST = 'RECEIVE_INVOICE_REQUEST'

export const REQUEST_CONFIRM_PRESENCE = 'REQUEST_CONFIRM_PRESENCE'
export const RECEIVE_CONFIRM_PRESENCE = 'RECEIVE_CONFIRM_PRESENCE'

export const REQUEST_ALL_CABINS = 'REQUEST_ALL_CABINS'
export const RECEIVE_ALL_CABINS = 'RECEIVE_ALL_CABINS'

export const REQUEST_CABIN = 'REQUEST_CABIN'
export const RECEIVE_CABIN = 'RECEIVE_CABIN'
